import { Localize } from "components/service";
import { Link } from "react-router-dom";
import Event from "components/events";
import GraphicStandFields from "../fields";
import StandFields from "components/stands/fields";

const graphicStandChoiseColumns = [
    {
        title: <Localize>TABLES.Column_Title_Exhibitor</Localize>,
        dataIndex: 'exhibitor',
        columnIndex: 'EXHIBITOR',
        sorter: true,
        fixed: 'left',
        width: 150,
    },
    {
        title: <Localize>TABLES.Column_Title_ExhibitionEvent</Localize>,
        dataIndex: 'exhibitionEvent',
        columnIndex: 'EE_ID',
        sorter: true,
        width: 250,
    },
    {
        title: <Localize>TABLES.Column_Title_Block</Localize>,
        dataIndex: 'block',
        columnIndex: 'BLOCK',
        sorter: true,
        width: 115,
    },
    {
        title: <Localize>TABLES.Column_Title_Stands</Localize>,
        dataIndex: 'stand',
        columnIndex: 'STAND_NUMBER',
        sorter: true,
        width: 115,
    },
    {
        title: <Localize>TABLES.Column_Title_Shelf</Localize>,
        dataIndex: 'shelfNo',
        columnIndex: 'SHELF_NUMBER',
        sorter: true,
        width: 115,
    },
    {
        title: <Localize>TABLES.Column_Title_ShelfDate</Localize>,
        dataIndex: 'shelf_date_at',
        columnIndex: 'SHELF_DATE_AT',
        sorter: true,
        width: 150,
    },
    {
        title: <Localize>TABLES.Column_Title_ShelfUser</Localize>,
        dataIndex: 'shelf_user',
        columnIndex: 'SHELF_USER_ID',
        sorter: true,
        width: 250,
    },
    {
        title: <Localize>TABLES.Column_Title_HallNew</Localize>,
        dataIndex: 'hall_new',
        columnIndex: 'HALL_NEW',
        width: 115,
        className: 'padding-x-5',
        align: 'center',
        // sorter: true,
    },
    {
        title: <Localize>TABLES.Column_Title_CorridorNew</Localize>,
        dataIndex: 'corridor',
        columnIndex: 'CORRIDOR',
        width: 115,
        className: 'padding-x-5',
        align: 'center',
        // sorter: true,
    },
    {
        title: <Localize>TABLES.Column_Title_BlockNew</Localize>,
        dataIndex: 'block_new',
        columnIndex: 'BLOCK_NEW',
        width: 115,
        className: 'padding-x-5',
        align: 'center',
        // sorter: true,
    },
    {
        title: <Localize>TABLES.Column_Title_StandNew</Localize>,
        dataIndex: 'stand_new',
        columnIndex: 'STAND_NEW',
        width: 115,
        className: 'padding-x-5',
        align: 'center',
        // sorter: true,
    },
    {
        title: <Localize>TABLES.Column_Title_Materials</Localize>,
        dataIndex: 'materials',
        columnIndex: 'MATERIALS',
        width: 80,
    },
    {
        title: <Localize>TABLES.Column_Title_Outsourced</Localize>,
        dataIndex: 'actions',
        columnIndex: 'ACTIONS',
        fixed: 'right',
        width: 70,
        align: 'center',
    },
];

const graphicStandChoiseData = (stands, currentObj) => {
    if (!stands) {
        return [];
    }

    const graphicPackingId = currentObj?.graphicPackingId;

    return stands
        .map(stand => {
        return {
            key: stand.id,
            exhibitor: (
                <Link to={`${Event.Const.basePath}/${stand.exhibitionEvent?.id}/stands/${stand.id}`}>
                    {stand.exhibitor || <strong>&mdash;</strong>}
                </Link>
            ),
            exhibitionEvent: (
                <Link to={`${Event.Const.basePath}/${stand.exhibitionEvent?.id}`}>
                    {stand.exhibitionEvent?.title || <strong>&mdash;</strong>}
                </Link>
            ),
            block: stand.block || <strong>&mdash;</strong>,
            stand: stand.stand_number || <strong>&mdash;</strong>,
            shelfNo: <GraphicStandFields.Shelf stand={stand} />,
            shelf_date_at: <StandFields.ShelfDate date={ stand.shelf_date_at } />,
            shelf_user: <StandFields.ShelfUser user={ stand.relShelfUser } />,
            hall_new: <GraphicStandFields.NewLocation field="hall" stand={stand} graphicPackingId={graphicPackingId} />,
            corridor: <GraphicStandFields.NewLocation field="corridor" stand={stand} graphicPackingId={graphicPackingId} />,
            block_new: <GraphicStandFields.NewLocation field="block" stand={stand} graphicPackingId={graphicPackingId} />,
            stand_new: <GraphicStandFields.NewLocation field="stand" stand={stand} graphicPackingId={graphicPackingId} />,
            materials: <GraphicStandFields.Graphic stand={stand} />,
            actions: <GraphicStandFields.CreateButton stand={stand} graphicPackingId={graphicPackingId} />
        };
    });
};


const GraphicStandChoiseTableHelper = {
    columns: graphicStandChoiseColumns,
    data: graphicStandChoiseData,
};

export default GraphicStandChoiseTableHelper;